// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__BQALU","content":"styles_content__S5VOz","checkbox":"styles_checkbox__1dL9C","checkboxLabel":"styles_checkboxLabel__3qFuM"};